export const getTopicIdAndName = (topic: string): [string, string] => {
  const hasColon = topic?.includes(":");
  if (hasColon) {
    const [url, name] = topic?.split(":")?.map((t) => t?.trim()) || [];
    return [url?.toLowerCase(), name];
  }

  return ["topics", topic?.trim()];
};
